import React, { useEffect } from 'react'
import Spinner from 'react-spinkit'
import get from 'lodash/get'
import { useDispatch, useSelector } from 'react-redux';
import { fetchStatisticRequested } from '../../store/analytics/actions';

const StatisticPage = () => {
  const dispatch = useDispatch()
  const {
    isEventsLoading: loading,
    events: statistic,
    error
  } = useSelector(state => state.analytics);
  // const [statistic, setStatistic] = useState(undefined)
  // const [loading, setLoading] = useState(false)
  // const [error, setError] = useState(false)
  useEffect(() => {
    dispatch(fetchStatisticRequested())
  }, [])

  if(error){
    return (<div className="form-group">
      <div className="alert alert-danger">
        <strong>Ошибка!</strong> {error}
      </div>
    </div>)
  }
  if(loading){
    return (   <div>
      <Spinner name="circle" className="spinner" fadeIn="quarter" color="#3897dc"/>
      <div className="overlay">
      </div>
    </div>)
  }

  return (
    <div  style={{ width: '100%' }}>
      <div>
        <h3>Статистика</h3>
      </div>
      <br/>
      {
        statistic !== undefined &&
        <div>
          <h2>Итого</h2>
          <br/>
          <h3>Связи</h3>
          <div className="table-responsive">
            {
              <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                <tbody>
                <tr>
                  <td>Подтверждено</td>
                  <td>{get(statistic,'relation_total.confirmed')}</td>
                </tr>
                <tr>
                  <td>Ожидают одобрения</td>
                  <td>{get(statistic,'relation_total.pending')}</td>
                </tr>
                </tbody>
              </table>
            }
          </div>
          <br/>
          <h3>Пользователи</h3>
          <div className="table-responsive">
            {
              <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                <tbody>
                <tr>
                  <td>Всего</td>
                  <td>{get(statistic, 'user_total.all')}</td>
                </tr>
                <tr>
                  <td>Зарегистрировано</td>
                  <td>{get(statistic, 'user_total.registered')}</td>
                </tr>
                </tbody>
              </table>
            }
          </div>
          <br/>
          <h3>По категориям</h3>
          <div className="table-responsive">
            {
              <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                <thead>
                <tr>
                  <th colSpan="2">Категория</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                {
                  get(statistic,'category_totals',[]).map((categoryTotal) => {
                    return [
                      <tr key={'category_totals_' + categoryTotal.skill.id}>
                        <td colSpan="2"><b>{categoryTotal.skill.name}</b></td>
                        <td>
                          <b>Связи: </b>
                          Подтверждено - {categoryTotal.relation_total.confirmed}&nbsp;
                          Ожидают одобрения - {categoryTotal.relation_total.pending}
                          <br/>
                          <b>Пользователи: </b>
                          Зарегистрировано - {categoryTotal.user_total.registered}
                        </td>
                      </tr>,
                      categoryTotal.children_skill_totals.map((skillTotal) =>
                        <tr key={'category_totals_' + categoryTotal.skill.id + '_children_' + skillTotal.skill.id}>
                          <td></td>
                          <td>{skillTotal.skill.name}</td>
                          <td>
                            <b>Связи: </b>
                            Подтверждено - {skillTotal.relation_total.confirmed}&nbsp;
                            Ожидают одобрения - {skillTotal.relation_total.pending}
                            <br/>
                            <b>Пользователи: </b>
                            Зарегистрировано - {skillTotal.user_total.registered}
                          </td>
                        </tr>
                      )
                    ]
                  })
                }
                </tbody>
              </table>
            }
          </div>
        </div>
      }
    </div>
  )
}

export default StatisticPage



// WEBPACK FOOTER //
// ./src/pages/StatisticPage/index.jsx